import api from '../../common/api';
import url from '../../common/url';

const ADMIN_AREA_4 = 4; // Municipality in Norway

export default {
    namespaced: true,
    state: {
        parentRegion: null,
        regions: [],
        isLoading: false,
        defaultRegion: null,
    },
    mutations: {
        setDefaultRegion(state, region) {
            state.defaultRegion = region;
        },
        setParentRegion(state, region) {
            state.parentRegion = region;
            state.regions = [];
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        addItems(state, items) {
            state.regions = [...state.regions, ...items];
        },
    },
    actions: {
        loadDefaultRegion(context) {
            context.dispatch('loadRegion', context.rootState.session.country);
        },
        async loadParentRegion(context, region) {
            context.commit('setIsLoading', true);
            const parent = await api.get(url.getRegionParent(region.id));
            context.commit('setIsLoading', false);
            if (parent.error) context.dispatch('loadDefaultRegion');
            else context.dispatch('loadRegion', parent);
        },
        loadRegion(context, region) {
            context.commit('setParentRegion', region);
            const uri = region.level < ADMIN_AREA_4 ? url.getRegionChildren(region.id) : url.getRegionDescendants(region.id);
            context.dispatch('loadSubRegions', uri);
        },
        async loadSubRegions(context, uri) {
            if (!uri) return;
            context.commit('setIsLoading', true);
            const page = await api.get(uri);
            context.commit('setIsLoading', false);
            if (page.error) return;
            context.commit('addItems', page.items);
            context.dispatch('loadSubRegions', page.nextUri);
        },
    },
};
